var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "js-right-sidebar",
    attrs: {
      "href": "javascript:void(0);",
      "data-close": "true"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign Out")])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-bar"
  }, [_c('div', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "START TYPING..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-search"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bars",
    attrs: {
      "href": "javascript:void(0);"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("ADMIN - DAPENBI")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52186acf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = ZQXr
// module chunks = 1